import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Chip } from '@mui/material'
import T from 'T'
import { grey } from '@mui/material/colors'

const DateRangePresets = ({ activePreset, onPresetClick }) => {
  const presets = [
    { label: T.TODAY, value: 'today' },
    { label: T.THIS_WEEK, value: 'thisWeek' },
    { label: T.LAST_WEEK, value: 'lastWeek' },
    { label: T.LAST_7_DAYS, value: 'last7Days' },
    { label: T.LAST_UPCOMING_WEEK, value: 'lastUpcomingWeek' },
    { label: T.CURRENT_MONTH, value: 'currentMonth' },
    { label: T.NEXT_MONTH, value: 'nextMonth' },
    { label: T.NEXT_QUARTER, value: 'nextQuarter' },
    { label: T.NEXT_6_MONTHS, value: 'next6Months' },
    { label: T.THIS_YEAR, value: 'thisYear' },
    { label: T.RESET, value: 'reset' },
  ]

  return (
    <Stack
      gap={{ xs: 1.5, md: 1 }}
      sx={{
        minWidth: { xs: '100%', md: 200 },
        flexShrink: 0,
        alignItems: 'center',
        mt: { xs: 0, md: 2 },
        flexDirection: { xs: 'row', md: 'column' },
        flexWrap: { xs: 'wrap', md: 'nowrap' },
      }}
    >
      {presets.map(preset => (
        <Chip
          key={preset.value}
          label={preset.label}
          size="small"
          onClick={() => onPresetClick(preset.value)}
          sx={{
            '&.MuiChip-root': {
              backgroundColor: activePreset === preset.value ? grey[300] : grey[100],
              color: preset.value === 'reset' ? 'primary.main' : 'primary',
              borderColor: preset.value === 'reset' ? grey[300] : 'transparent',
              borderWidth: 1,
              borderStyle: 'solid',
              fontSize: 12,
              padding: '4px 8px',
            },
          }}
        />
      ))}
    </Stack>
  )
}

DateRangePresets.propTypes = {
  activePreset: PropTypes.string,
  onPresetClick: PropTypes.func.isRequired,
}

export default DateRangePresets
